module.exports = __webpack_public_path__ + "static/media/Belize.63a93d2e.png";